import { render, staticRenderFns } from "./FinishChips.vue?vue&type=template&id=5d7bb7ae"
import script from "./FinishChips.vue?vue&type=script&lang=js"
export * from "./FinishChips.vue?vue&type=script&lang=js"
import style0 from "./FinishChips.vue?vue&type=style&index=0&id=5d7bb7ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports